import { render, staticRenderFns } from "./MemberCardList.vue?vue&type=template&id=6dd7f734&scoped=true"
import script from "./MemberCardList.vue?vue&type=script&lang=js"
export * from "./MemberCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd7f734",
  null
  
)

export default component.exports